import React, { useState } from "react";
import { Grid, IconButton, Typography, Checkbox, TextField } from "@mui/material";
import { Save, Edit, Delete } from "@mui/icons-material";
import { get, post, request } from "../../../../requests";

interface EditStipulationDetailsComponentProps {
  stip: {
    id: number;
    type: string;
    default: boolean;
  };
  getAllStips: () => void;
}

const EditStipulationDetailsComponent: React.FC<EditStipulationDetailsComponentProps> = ({
  stip,
  getAllStips,
}) => {
  const { default: removedDefault, ...rest } = stip;
  const [editedStip, setEditedStip] = useState({ ...rest, isDefault: stip.default });
  const [editMode, setEditMode] = useState(false);

  const handleTypeChange = (value: string) => {
    setEditedStip((prevState) => ({
      ...prevState,
      type: value,
    }));
  };

  const handleDefaultChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditedStip((prevState) => ({
      ...prevState,
      isDefault: e.target.checked,
    }));
  };

  const editStip = () => {
    post("stipulations/editStipulation", editedStip).then(() => {
      getAllStips();
      setEditMode(false);
    });
  };

  const deleteStip = (stipulationId: number) => {
    request("delete", `stipulations/deleteStipulation/${stipulationId}`).then(() => {
      getAllStips();
    });
  };

  return (
    <React.Fragment>
      <Grid container item xs={8} alignItems="center">
        {editMode ? (
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            value={editedStip.type}
            onChange={(e) => handleTypeChange(e.target.value)}
            inputProps={{ style: { fontSize: 14 } }}
          />
        ) : (
          <Typography style={{ fontSize: "16px", overflowWrap: "anywhere", color: "#000" }}>
            {editedStip.type}
          </Typography>
        )}
      </Grid>
      <Grid container item xs={2} alignItems="center">
        <Checkbox
          checked={editedStip.isDefault}
          onChange={handleDefaultChange}
          disabled={!editMode}
          sx={{
            color: editMode ? "#000" : "#424242",
            "&.Mui-checked": {
              color: "#1E88E5",
            },
          }}
        />
      </Grid>
      <Grid container item xs={2} alignItems="center">
        {!editMode && (
          <div style={{ display: "flex" }}>
            <IconButton onClick={() => setEditMode(true)} sx={{ color: "#1565C0" }}>
              <Edit style={{ fontSize: "18px" }} />
            </IconButton>
            <IconButton onClick={() => deleteStip(stip.id)} sx={{ color: "#D32F2F" }}>
              <Delete color="error" style={{ fontSize: "18px", marginLeft: 0 }} />
            </IconButton>
          </div>
        )}
        {editMode && (
          <IconButton onClick={editStip} sx={{ color: "#2E7D32" }}>
            <Save style={{ fontSize: "20px" }} />
          </IconButton>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default EditStipulationDetailsComponent;
